module.exports = __webpack_public_path__ + "static/media/customize-icon.5d2640eb.svg";